import { Component, Input } from '@angular/core';
import { Translate } from '../../utils/translate';
import { RequestType } from '../../model/requestType.enum';

@Component({
  selector: 'app-request-data',
  templateUrl: './request-data.component.html',
  styleUrls: ['./request-data.component.scss']
})
export class RequestDataComponent {
  @Input() requestData?: any;
  requestTypeEnum = RequestType;

  constructor(public translate: Translate) {}
}
